module.exports = __webpack_public_path__ + "img/phone.ae665d8c.svg";